import { SET_FULL_PAGE_LOADING } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_FULL_PAGE_LOADING: {
            const fullPageLoading = action.payload;
            return Object.assign(Object.assign({}, state), { fullPageLoading });
        }
        default: {
            return state;
        }
    }
};
export { reducer };
